export default {"src":"/_next/static/media/microsoft-teams.3541fcdc.svg","height":20,"width":20};